<template>
    <div id="listContainer">
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form 
                    :form="queryForm" 
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear="handleInputClear"
                    @handlePickerDateChange="handlePickerDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>

        <div class="unoutboundCount">
            <a-button class="form_btn" type="primary" size="mini" v-permission="'setting.returnOrder.createReturnOrder'" :disabled="exporting" @click="handle('create')">
                <icon-plus size="13" style="marginRight:5px;"/>
                {{ $t('returnOrder.createReturnOrder') }}
            </a-button>
        </div>

        <Table 
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
            @cellDblClick="cellDblClick"
        >
            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'status'">
                    <a-tag :color="props.record.status_val == 1? 'red' : props.record.status_val == 2? 'green' : props.record.status_val == 3? 'orange' : 'gray' ">{{ props.record.status }}</a-tag>
                </div>
                <div v-if="props.column.key == 'logistics'" class="logisticsInfo">
                    <div>{{ $t('stock.logisticsType') }}：{{ props.record.courier_type }}</div>
                    <div>{{ $t('stock.logisticsNo') }}：{{ props.record.courier_no }}</div>
                </div>
                <div v-if="props.column.key == 'instruction' && userInfo.role != '8'" class="remark">
                    <a-tooltip :content="props.record.instruction">
                        <div class="remark_content" v-if="props.record.remarkIsText">{{ props.record.instruction }}</div>
                    </a-tooltip>
                    
                    <a-input v-if="!props.record.remarkIsText" :style="{width:'180px'}" v-model="props.record.instruction" />
                    <icon-check v-if="!props.record.remarkIsText" @click="saveComment(props.record)" :style="{display:'inline-block',marginLeft:'5px',color:'green',cursor:'pointer',fontWeight:'blod'}"/>
                    <icon-close v-if="!props.record.remarkIsText" @click="cancelSaveComment(props.record)" :style="{display:'inline-block',marginLeft:'10px',color:'red',cursor:'pointer',fontWeight:'blod'}"/>
                </div>
            </template>

            <template v-slot:tableOperate="{ props }">
                <a-button v-permission="'setting.stock.edit'"  type="primary" size="mini" :disabled="props.record.status_val == 3" style="margin-top:5px;width:72px" @click="handle('edit',props.record)">{{ $t('base.edit') }}</a-button>
            </template>
            
        </Table>

        <!-- 创建退货杂单 -->
        <a-modal
            v-model:visible="visible" 
            :title="$t('returnOrder.createReturnOrder')"
            :width="width"
            draggable
            :onBeforeOk="onBeforeOk" 
            popup-container="#listContainer"
        >
            <Form 
                class="returnForm"
                :form="addForm" 
                @handleInputChange="handleInputChange2"
                @handleSelectChange="handleSelectChange2"
                @handleSelectDate="handleSelectDate"
            ></Form>
            <Upload
                class="uploadImg"
                @changeUpload="changeUpload"
                @errorUpload="errorUpload"
            >
                <template #desc>
                    <div class="uploadDesc">{{ $t('returnExchange.uploadDesc') }}</div>
                </template>
            </Upload>

            <a-button class="form_btn" type="primary" size="mini" v-permission="'setting.stock.exportShipment'" :disabled="exporting" @click="handle('selectProduct')">
                <icon-plus size="13" style="marginRight:5px;"/>
                {{ $t('returnOrder.selectProduct') }}
            </a-button>

            <!-- 确认选择的产品 -->
            <Table :table="productTable">
                <template v-slot:columns="{ props }">
                    <div v-if="props.column.key == 'frame_number'">
                        <a-input :style="{width:'140px'}" :maxlength="24" v-model="props.record.frame_number" />
                    </div>
                    <div v-if="props.column.key == 'back_quantity'">
                        <a-inputNumber 
                            v-model="props.record.back_quantity" 
                            :style="{width:'70px'}" 
                            :min="0"
                            :hideButton="true"
                            disabled
                        />
                    </div>
                    <div v-if="props.column.key == 'instruction'">
                        <a-input :style="{width:'140px'}" v-if="props.record.show" v-model="props.record.instruction" />
                    </div>
                </template>

                <template v-slot:tableOperate="{ props }">
                    <icon-plus-circle v-if="props.record.addItem == undefined" size="20" @click="handle('addLine',props.record)" style="color:blue;cursor:pointer;"/>
                    <icon-minus-circle v-if="props.record.addItem" size="20" @click="handle('removeLine',props.record)" style="color:red;cursor:pointer"/>
                </template>
            </Table>
        </a-modal>

        <!-- 选择产品弹窗 -->
        <a-modal
            class="selectProduct"
            v-model:visible="selectProductVisible" 
            width="75%"
            :title="$t('returnOrder.selectProduct')"
            draggable
            :onBeforeOk="onSelectProductBeforeOk" 
            popup-container="#listContainer"
        >
            <Form 
                style="border-bottom: 1px dashed #ccc;"
                :form="productQueryForm" 
                @handleSelectChange="handleSelectChange3"
                @handlePressEnter="handlePressEnter3"
                @handleInputClear="handleInputClear3"
            ></Form>

            <Table
                ref="selectProductTableRef" 
                :table="selectProductTable"
                @selectRow="selectRow"
                @selectAllRow="selectAllRow"
            ></Table>
        </a-modal>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, computed, toRefs, h } from 'vue';
    import { useRouter } from 'vue-router';
    import { ReturnOrderApi } from '@/api/ReturnOrderApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { StockOutApi } from '@/api/StockOutApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import Upload from '@/components/Upload.vue';
    import { QueryForm, AddForm, ProductQueryForm } from './queryConfig/QueryForm.js';
    import { dateToTimestamp, timestampToDate, getNowDate } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';

    const  { t } = useI18n()

    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    const showForm = ref(false)
    const visible = ref(false)
    const selectProductVisible = ref(false)
    const width = ref('75%')
    const queryForm = reactive(QueryForm)
    const addForm = reactive(AddForm)
    const productQueryForm = reactive(ProductQueryForm)
    const selectedArr = ref([])
    const selectProductTableRef = ref(null)
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'50',
                fixed:'left',
                align:'left',
            },
            {
                // title: '退货单号',
                title: t('returnOrder.backNumber'),
                dataIndex: 'back_number',
                key:'back_number',
                width:'220',
                ellipsis:true,
                tooltip:true,  
                // fixed:'left',
                align:'left',
            },
            {
                // title: 'sku',
                title: t('order.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'200',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: '出库状态',
                title: t('order.outboundStatus'),
                dataIndex: 'status',
                key:'status',
                width:'160',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '产品名称',
                title: t('order.productName'),
                dataIndex: 'name',
                key:'name',
                width:'200',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: '车型',
                title:t('order.model'),
                dataIndex: 'model',
                key:'model',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '上市年份',
                title:t('order.modelYear'),
                dataIndex: 'model_year',
                key:'model_year',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '品牌名称',
                title:t('order.brandName'),
                dataIndex: 'brand_name',
                key:'brand_name',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '零件名称',
                title:t('order.partName'),
                dataIndex: 'part_name',
                key:'part_name',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '车架号',
                title: t('order.frameNumber'),
                dataIndex: 'frame_number',
                key:'frame_number',
                width:'250',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '数量',
                title: t('stock.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '退货时间',
                title: t('returnOrder.returnDate'),
                dataIndex: 'back_timestamp',
                key:'back_timestamp',
                width:'170',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            // {
            //     // title: '预计收货时间',
            //     title: t('stock.transactionDate'),
            //     dataIndex: 'transaction_date',
            //     key:'transaction_date',
            //     width:'170',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            //     slotName:'slot'
            // },
            // {
            //     // title: '实际收货时间',
            //     title: t('stock.deliveryDate'),
            //     dataIndex: 'delivery_date',
            //     key:'delivery_date',
            //     width:'180',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            //     slotName:'slot'
            // },
            {
                // title: '创建时间',
                title: t('order.createDate'),
                dataIndex: 'create_date',
                key:'create_date',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '物流信息',
                title: t('stock.logistics'),
                dataIndex: 'logistics',
                key:'logistics',
                width:'220',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '运费',
                title: t('stock.cargoFreight'),
                dataIndex: 'cargo_freight',
                key:'cargo_freight',
                width:'140',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: 'PO号',
                title: t('stock.po'),
                dataIndex: 'po',
                key:'po',
                width:'250',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            // {
            //     // title: 'erp订单号',
            //     title: t('order.erpNo'),
            //     dataIndex: 'erp_no',
            //     key:'erp_no',
            //     width:'160',
            //     ellipsis:true,
            //     tooltip:true,  
            //     align:'left',
            // },
            // {
            //     // title: 'erp物料号',
            //     title: t('order.inventoryCode'),
            //     dataIndex: 'inventory_code',
            //     key:'inventory_code',
            //     width:'160',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            // },
            // {
            //     // title: '仓库',
            //     title: t('order.warehouse'),
            //     dataIndex: 'warehouse',
            //     key:'warehouse',
            //     width:'130',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            // },
            {
                // title: '创建人',
                title: t('order.createUser'),
                dataIndex: 'create_user',
                key:'create_user',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '备注',
                title: t('stock.remark'),
                dataIndex: 'instruction',
                key:'instruction',
                width:'270',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            // {
            //     title: t('base.operate'),
            //     dataIndex: 'Optional',
            //     key:'Optional',
            //     slotName:'optional',
            //     width:'110',
            //     align:'left',
            //     fixed:'right'
            // }
        ],
        configs:{
            scroll:{
                x:1000,
                y:680,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                size:'mini',
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })
    const productTable = ref({
        datas:[],
        columns:[
            {
                // title: '产品名称',
                title: t('order.productName'),
                dataIndex: 'name',
                key:'name',
                ellipsis:true,
                tooltip:true,  
                align:'left',
                width:'400',
            },
            {
                // title: 'sku',
                title: t('order.sku'),
                dataIndex: 'sku',
                key:'sku',
                ellipsis:true,
                tooltip:true,  
                align:'left',
                width:'200',
            },
            {
                // title: '物料编码',
                title: t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                key:'inventory_code',
                ellipsis:true,
                tooltip:true,
                align:'left',
                width:'200',
            },
            {
                // title: '车架号',
                title: t('order.frameNumber'),
                dataIndex: 'frame_number',
                key:'frame_number',
                ellipsis:true,
                tooltip:true,
                align:'left',
                width:'190',
                slotName:'slot'
            },
            {
                // title: '退回数量',
                title: t('order.backQuantity'),
                dataIndex: 'back_quantity',
                key:'back_quantity',
                ellipsis:true,
                tooltip:true,
                align:'left',
                width:'110',
                slotName:'slot'
            },
            {
                // title: '备注',
                title: t('stock.remark'),
                dataIndex: 'instruction',
                key:'instruction',
                ellipsis:true,
                tooltip:true,
                align:'left',
                width:'190',
                slotName:'slot'
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width: '80',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                x:1000,
                y:480,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            // dataSpanMethod:({record, column})=>{
            //     let arr = ['name','sku','inventory_code']
            //     if (record.sku === '10107002H49BL' && column.dataIndex === 'name') {
            //         return {
            //             rowspan: 2,
            //         }
            //     }
            // },
            pagination:false,
        },
    })
    const selectProductTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'100',
                fixed:'left',
                align:'left',
            },
            {
                // title: '产品名称',
                title: t('order.productName'),
                dataIndex: 'name',
                key:'name',
                ellipsis:true,
                tooltip:true,  
                align:'left',
                width:'400',
            },
            {
                // title: '车型',
                title:t('order.model'),
                dataIndex: 'model',
                key:'model',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '上市年份',
                title:t('order.modelYear'),
                dataIndex: 'model_year',
                key:'model_year',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '品牌名称',
                title:t('order.brandName'),
                dataIndex: 'brand_name',
                key:'brand_name',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '零件名称',
                title:t('order.partName'),
                dataIndex: 'part_name',
                key:'part_name',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'sku',
                title: t('order.sku'),
                dataIndex: 'sku',
                key:'sku',
                ellipsis:true,
                tooltip:true,  
                align:'left',
                width:'150',
            },
            {
                // title: '物料编码',
                title: t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                key:'inventory_code',
                ellipsis:true,
                tooltip:true,
                align:'left',
                width:'150',
            },
        ],
        configs:{
            scroll:{
                x:1000,
                y:480,
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            rowSelection:{
                type: 'checkbox',
                showCheckedAll: true,
                onlyCurrent: false,
            },
            pagination:false,
            
        },
    })

    const handle = (type, row)=>{
        switch(type){
            case 'search':
                getReturnOrderList()
                break;
            case 'reset':
                queryForm.formField.forEach(i=>{
                    queryForm.formData[i.key] = ''
                })
                table.value.configs.pagination.current = 1
                getReturnOrderList()
                break;
            case 'create':
                visible.value = true
                productTable.value.datas = []
                if(selectProductTableRef.value) selectProductTableRef.value.selectedKeys = []
                if(selectProductTableRef.value) selectProductTableRef.value.selectedData = []
                selectedArr.value = []
                getRefundReasonType()
                getIBSVerificationType()
                getCourierType()

                addForm.formField.forEach(i=>{
                    addForm.formData[i.key] = ''
                    if(i.key == 'courier_no'){
                        i.disabled = true
                    }
                })
                break;
            case 'selectProduct':  
                selectProductVisible.value = true
                if(productTable.value.datas.length > 0){
                    selectProductTableRef.value.selectedKeys = []
                    selectProductTableRef.value.selectedData = []
                    selectedArr.value.forEach(i=>{
                        selectProductTableRef.value.selectedKeys.push(i.id)
                        selectProductTableRef.value.selectedData.push(i)
                    })
                }else{
                    if(selectProductTableRef.value) selectProductTableRef.value.selectedKeys = []
                    if(selectProductTableRef.value) selectProductTableRef.value.selectedData = []
                }
                break;
            case 'addLine':
                productTable.value.datas.splice(row.index + 1, 0, {
                    ...row, 
                    frame_number:'',
                    back_quantity:1, 
                    instruction:'', 
                    addItem:true, 
                    show:false,
                })
                productTable.value.datas.forEach((item,index)=>{
                    item.index = index
                })
                break;
            case 'removeLine':
                productTable.value.datas.splice(row.index, 1)
                productTable.value.datas.forEach((item,index)=>{
                    item.index = index
                })
                break;
        }
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getReturnOrderList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getReturnOrderList()
    }

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    // 双击单元格
    const cellDblClick = (row,column)=>{
        // console.log(column,'col')
        if(column.key == 'instruction'){
            row.remarkIsText = false
        }
    }

    const cancelSaveComment = (row)=>{
        row.remarkIsText = true
        getReturnOrderList()
    }

    // 保存备注
    const saveComment = async (row)=>{
        let param = {
            id:row.id,
            instruction:row.instruction,
        }
        let res = await ReturnOrderApi.getInstance().saveComment(param)
        if(res.code == 0){
            Message.success(t('base.saveSuccess'))
            row.remarkIsText = true
            getReturnOrderList()
        }else{
            Message.error(res.msg)
        }
    }

    // 列表查询-input
    const handleSelectChange = ()=>{
        table.value.configs.pagination.current = 1
        getReturnOrderList()
    }
    const handleInputClear = (item, val)=>{
        table.value.configs.pagination.current = 1
        getReturnOrderList()
    }
    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getReturnOrderList()
    }
    const handlePickerDateChange = (val,item)=>{
        console.log(val,item,'iooooooo')
        table.value.configs.pagination.current = 1
        if(item.key === 'back_timestamp'){
            queryForm.formData.back_end_plan_date = !val? '' : dateToTimestamp(`${val[0]} 00:00:00`)
            queryForm.formData.back_begin_plan_date = !val? '' : dateToTimestamp(`${val[1]} 23:59:59`) 
        }
        if(item.key === 'back_real_timestamp'){
            queryForm.formData.back_begin_real_date = !val? '' : dateToTimestamp(`${val[0]} 00:00:00`)
            queryForm.formData.back_end_real_date = !val? '' : dateToTimestamp(`${val[1]} 23:59:59`) 
        }
        
        getReturnOrderList()
    }

    const handleSelectChange2 = (val,opt,key)=>{
        // console.log(val,opt,key,'key')
        // if(key == 'courier_type' && !!val){
        //     getCourierId()
        // }

        if(key == 'courier_type'){
            let courierNoItem = addForm.formField.find(i=> i.key == 'courier_no')
            courierNoItem.required = !!addForm.formData.courier_type
            if(!!val && addForm.formData.courier_no === ''){
                courierNoItem.disabled = false
            }else if(!!val && addForm.formData.courier_no !== ''){
                getCourierId()
            }else{
                addForm.formData.courier_no = ''
                addForm.formData.courier_id = ''
                courierNoItem.disabled = true
            }
        }
    }

    const handleInputChange2 = (item,val)=>{
        // console.log(item,val,'val,opt,item7777')
        // if(item.key == 'courier_no'){
        //     let courierTypeItem = addForm.formField.find(i=> i.key == 'courier_type')
        //     if(!!val){
        //         courierTypeItem.disabled = false
        //     }else{
        //         addForm.formData.courier_type = ''
        //         addForm.formData.back_courier_id = ''
        //         courierTypeItem.disabled = true
        //     }
        // }

        if(item.key == 'courier_no' && !!val){
            getCourierId()
        }else if(!val){
            addForm.formData.courier_id = ''
        }
    }

    const handleSelectDate = (val,date,item)=>{
        console.log(val,date,item,'val,date,item')
        // if(earliest_ship_timestamp < order_timestamp){
        //         Modal.warning({
        //             title: t('base.tip'),
        //             titleAlign:'start',
        //             content: t('order.earliestShipmentDate'),
        //             hideCancel:true,
        //             okText:t('base.ok'),
        //             cancelText:t('base.cancel'),
        //             onOk:()=>{
        //                 createOrderForm1.formData.earliest_ship_timestamp = ''
        //             }
        //         });
        // } 
    }

    // 上传中
    const changeUpload = (fileList)=>{
        let arr = []
        if(fileList.length > 0){
            fileList.forEach(i=>{
                if(i.status == 'done'){
                    arr.push(i.response.data)
                }
            })
        }
        addForm.formData.file = arr.join(',')
    }

    // 上传失败
    const errorUpload = (fileItem)=>{
        Message.error(t('returnExchange.uploadFail'))
    }

    // 选择产品-查询
    const handleSelectChange3 = (val,item,key)=>{
        getProductList()
    }
    const handleInputClear3 = (item, val)=>{
        getProductList()
    }
    const handlePressEnter3 = (val,item)=>{
        getProductList()
    }

    // 选择产品-勾选
    const selectRow = (selected)=>{
        // console.log(selected,'selected')
        selectedArr.value = []
        selected.forEach(i=>{
            i.frame_number = ''
            i.back_quantity = ''
            i.instruction = ''
            selectedArr.value.push(i)
        })
    }

    // 选择产品-全选
    const selectAllRow = (selected)=>{
        selectedArr.value = []
        selected.forEach(i=>{
            i.frame_number = ''
            i.back_quantity = ''
            i.instruction = ''
            selectedArr.value.push(i)
        })
    }

    // 获取退货杂单列表
    const getReturnOrderList = async()=>{
        let form = {}
        queryForm.formField.forEach(i=>{
            if(i.key !== 'back_timestamp' && i.key !== 'back_real_timestamp'){
                form[i.key] = queryForm.formData[i.key]
            }
        })
        let param = {
            ...form,
            type:5,
            back_begin_plan_date: !queryForm.formData.back_timestamp? '' : dateToTimestamp(`${queryForm.formData.back_timestamp[0]} 00:00:00 `),
            back_end_plan_date: !queryForm.formData.back_timestamp? '' : dateToTimestamp(`${queryForm.formData.back_timestamp[1]} 23:59:59`),
            back_begin_real_date: !queryForm.formData.back_real_timestamp? '' : dateToTimestamp(`${queryForm.formData.back_real_timestamp[0]} 00:00:00 `),
            back_end_real_date:!queryForm.formData.back_real_timestamp? '' : dateToTimestamp(`${queryForm.formData.back_real_timestamp[1]} 23:59:59`),
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await ReturnOrderApi.getInstance().getReturnOrderList(param, page_num, page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.forEach((i,index)=>{
                table.value.datas.push({
                    ...i,
                    No: index + 1,
                    name:i.product_map.english_name,
                    sku:i.product_map.sku,
                    frame_number: i.attribute1,
                    back_timestamp: timestampToDate(i.back_timestamp * 1000),
                    status_val:i.status,
                    status: i.status == 1? t('returnOrder.returning') : t('returnOrder.returnSuccesful'),
                    courier_type: i.back_courier_map? i.back_courier_map.courier_type : '-',
                    courier_no: i.back_courier_map? i.back_courier_map.courier_no : '-',
                    cargo_freight:i.cargo_freight? i.cargo_freight : '-',
                    po:i.po? i.po : '-',
                    remarkIsText:true,
                    model: i.product_map == undefined? '-' : i.product_map.model == undefined? '-' : i.product_map.model,
                    model_year: i.product_map == undefined? '-' : i.product_map.model_year == undefined? '-' : i.product_map.model_year,
                    brand_name: i.product_map == undefined? '-' : i.product_map.brand_name == undefined? '-' : i.product_map.brand_name,
                    part_name: i.product_map == undefined? '-' : i.product_map.part_name == undefined? '-' : i.product_map.part_name,
                })
            })
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 创建退货杂单校验
    const onBeforeOk = ()=>{
        if(!addForm.formData.back_reason_type){
            Message.error(t('returnExchange.backReasonType') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addForm.formData.back_reason){
            Message.error(t('returnExchange.backReason') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addForm.formData.back_timestamp){
            Message.error(t('returnExchange.backTimestamp') + ' ' + t('base.noEmpty'))
            return false
        }else if(!!addForm.formData.courier_type && !addForm.formData.courier_no){
            Message.error(t('returnOrder.courierNo')+ ' ' + t('base.noEmpty'))
            return false
        }else if(productTable.value.datas.length == 0){
            Message.error(t('returnOrder.selectProductMsg'))
            return false
        }

        for(let i=0;i<productTable.value.datas.length;i++){
            let item = productTable.value.datas[i]
            if(item.frame_number === ''){
                Message.error(t('order.frameNumber') + ' ' + t('base.noEmpty'))
                return false
            }else if(item.back_quantity === ''){
                Message.error(t('order.backQuantity') + ' ' + t('base.noEmpty'))
                return false
            }
        }

        createReturnOrder()

        return false
    }

    // 创建退货杂单
    const createReturnOrder = async()=>{
        let arr = []
        for(let i=0;i<productTable.value.datas.length;i++){
            let item = productTable.value.datas[i]
            if(arr.length == 0){
                arr.push(item)
            }else{
                let sku = []
                arr.forEach(i=>{
                    sku.push(i.sku)
                })
                for(let k=0;k<arr.length;k++){
                    if(item.sku == arr[k].sku){
                        arr[k].back_quantity += 1
                        arr[k].frame_number = arr[k].frame_number +','+ item.frame_number
                    }else{
                        if(!sku.includes(item.sku)){
                            arr.push(item)  
                            break;
                        }
                    }
                }
            }
        }
        productTable.value.datas = [...arr]

        let param = []
        productTable.value.datas.forEach(i=>{
            param.push({   
                type:5,
                status:1,
                stock_out_id:0,
                discount:0,
                order_id:0,
                order_line_id:0,
                customer_id:0,
                // customer_name:'',
                source:0,
                ...addForm.formData,
                back_timestamp:dateToTimestamp(addForm.formData.back_timestamp),
                back_courier_id: addForm.formData.back_courier_id? addForm.formData.back_courier_id : '',
                sku:i.sku,
                inventory_code:i.inventory_code,
                attribute1: i.frame_number.trim(),
                quantity:i.back_quantity,
                instruction:i.instruction,
            })
        })
        
        // console.log(param,'param')
        let res = await ReturnOrderApi.getInstance().createReturnOrder(param, 0, 5)
        if(res.code == 0){
            Message.success(t('base.addSuccess'))
            visible.value = false
            getReturnOrderList()
        }else{
            Message.error(res.msg)
        }
    }

    // 获取产品列表
    const getProductList = async ()=>{
        let param = {
            english_name: productQueryForm.formData.name,
            sku: productQueryForm.formData.sku,
            inventory_code: productQueryForm.formData.inventory_code,
            simple_flag:1,
        }
        selectProductTable.value.configs.loading = true
        let res = await ReturnOrderApi.getInstance().getProductList(param)
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'sku')
            let sku_item = productQueryForm.formField.find(i=> i.key == 'sku')
            let inventory_code_item = productQueryForm.formField.find(i=> i.key == 'inventory_code')
            
            selectProductTable.value.datas = []
            res.data.length > 0 && res.data.forEach((i,index)=>{
                selectProductTable.value.datas.push({
                    ...i,
                    No: index + 1,
                    show: true,
                    name:i.english_name,
                    model: i.model == undefined? '-' : i.model,
                    model_year: i.model_year == undefined? '-' : i.model_year,
                    brand_name: i.brand_name == undefined? '-' : i.brand_name,
                    part_name: i.part_name == undefined? '-' : i.part_name,
                })
                item.options.push({
                    label:i.sku,
                    value:i.sku,
                })
                sku_item.options.push({
                    label:i.sku,
                    value:i.sku,
                })
                inventory_code_item.options.push({
                    label:i.inventory_code,
                    value:i.inventory_code,
                })
            })
            selectProductTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 确认选择产品
    const onSelectProductBeforeOk = ()=>{
        if(selectedArr.value.length === 0){
            Message.error(t('returnOrder.selectProductMsg'))
            return false
        }

        let sku1 = [], sku2 = [], arr = []
        selectedArr.value.forEach(i=>{
            sku1.push(i.sku)
        })

        productTable.value.datas.forEach(i=>{
            if(sku1.includes(i.sku)){
                arr.push(i)
            }
        })

        arr.forEach(i=>{
            sku2.push(i.sku)
        })

        selectedArr.value.forEach(i=>{
            if(!sku2.includes(i.sku)){
                arr.push(i)
            }
        })

        productTable.value.datas = []
        arr.forEach((item,index)=>{
            productTable.value.datas.push({
                ...item,
                index,
                back_quantity:1, 
            })
        })
        return true
    }

    // 获取退款原因类型
    const getRefundReasonType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "order",dict_sub_code: "refund_reason_type"})
        if(res.code == 0){
            let item = addForm.formField.find(i=> i.key == 'back_reason_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.dict_sub_name,
                    value:i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取IBS验证方案类型
    const getIBSVerificationType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "order",dict_sub_code: "IBS_verification_type"})
        if(res.code == 0){
            let item = addForm.formField.find(i=> i.key == 'ibs_verification_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.dict_sub_name,
                    value:i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取物流公司
    const getCourierType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "courier_back"})
        if(res.code == 0){
            let item = addForm.formField.find(i=> i.key == 'courier_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: i.dict_sub_name,
                    value: i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取退货物流id
    const getCourierId = async ()=>{
        let param = {
            courier_type: addForm.formData.courier_type,
            courier_no: addForm.formData.courier_no,
        }
        let res = await OrderApi.getInstance().getCourierId(param)
        if(res.code == 0){
            addForm.formData.back_courier_id = res.data.id
        }else{
            Message.error(res.msg)
        }
    }

    // 获取创建人
    const getUser = async()=>{
        let res = await StockOutApi.getInstance().getUser()
        if(res.code == 0){
            const item = queryForm.formField.find(i=> i.key == 'create_by')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: i.user_name,
                    value: i.id,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    onMounted(()=>{
        getReturnOrderList()
        getProductList()
        getUser()
    })
</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:10;
        flex-direction: column;
        height: 33px;
        overflow: hidden;
        // margin-left: -30px;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }

        /deep/ .arco-form-item-layout-inline{
            margin-right: 0px;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_form2{
        flex:8;
    }
    .queryPanel_btn{
        display: flex;
        // flex-direction: column;
        // flex-wrap:wrap;
        flex: 1;
        align-items: center;
        justify-content: center;
        border-left:1px solid #eee;
        padding-left:10px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    .queryPanel_btn2{
        flex: 1;
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-picker-size-medium{
    height: 28px;
    margin-top: 2px;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 3px 0;
    font-size:13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}


/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}


/deep/ .arco-divider-text{
    font-weight:600;
}

.customer_info{
    font-size:13px;
    color: #666;
    padding: 0 10px;
    line-height: 25px;
}

/deep/ .arco-tabs-nav-type-line .arco-tabs-tab{
    padding:3px 0;
}

/deep/ .arco-tabs-content{
    padding-top: 7px;
}

.unoutboundCount{
    margin-bottom: 7px;
    padding: 5px 24px 5px;
    background: #fff;
}

.returnForm{
    min-width: 70%;
    max-width:75%;
    margin:0 auto;
    padding:20px;

    /deep/ .arco-form{
        display: block;
        text-align: center;
    }

    /deep/ .arco-input-wrapper .arco-input{
        height: 30px;
        width:100%;
    }

    /deep/ .arco-select,
    /deep/ .arco-textarea,
    /deep/ .arco-picker{
        height: 40px;
    }
}

.uploadImg{
    /deep/ .arco-form-item-content-flex{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 8px;
        margin-left: 20px;
    }
}
.uploadDesc{
    margin-bottom: 3px;
    font-size: 12px;
    color: #4d83ff;
}   

.selectProduct{
    ::v-deep .table_pagination{
        display: none !important;
    }
}
</style>